function broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    let name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    }
    if (child.$children.length) {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

import * as types from '../store/mutation-types';
import {formatDate} from 'element-ui/src/utils/date-util';
import { addClass, removeClass } from 'jyutils/dom';
import { getAbsPoint } from 'jyutils/utils';
export default {
  data() {
    return {
      editData: {},
      originData: ''
    }
  },
  computed: {
    rootPath() {
      return this.$axios.defaults.baseURL +'/';
    },
    assetsPath() {
      return process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ASSETPATH_PRD : process.env.VUE_APP_ASSETPATH_DEV;
    },
    BASEPATH() {
      return process.env.NODE_ENV === 'production' ? 'http://'+ location.host : 'http://'+ location.host;
    },
    sitetitle() {
      return this.apptitle || '小记者';
    },
    sitelogo() {
      return this.assetsPath +'static/images/'+ (process.env.VUE_APP_LOGO || 'logo.jpg') +'?t='+ Date.now();
    },
    wxname() {
      return process.env.VUE_APP_WEIXIN_NAME || '小记者';
    },
    finishedtext() {
      return process.env.VUE_APP_LOAD_FINISH || '小记者';
    },
    userinfo() {
      return this.$store.state.userinfo;
    },
    member() {
      return this.$store.getters.member;
    },
    settingvue() {
      return this.$store.getters.settingvue;
    },
    isSm() {
      return this.$store.state.isSm;
    },
    issys() {
      return this.userinfo.issys;
    },
    isAgent() {
      return this.userinfo.type === 5;
    },
    units() {
      return this.userinfo.unitList;
    },
    allUnitList() {
      return this.userinfo.allUnitList;
    },
    weeks() {
      return ['一','二','三','四','五','六','日']
    },
    getRandom() {
      return parseInt(1000000 * Math.random());
    },
    uploadPic() {
      return this.rootPath +'sys/utils/uploadPic';
    },
    headers() {
      return {Authorization: this.$store.getters.token || this.$store.getters.mtoken || 'token'};
    },
    noimg() {
      return this.assetsPath + 'static/images/noimg.jpg';
    },
    isWeixin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          return true;
      } else {
          return false;
      }
    },
  },
  methods: {
    getParent(componentName) {
      if (!componentName) {
        return undefined
      }
      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }

      return parent;
    },
    dispatch(componentName, eventName, params) {
      let parent = this.getParent(componentName);
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    },
    timeout() {
      this.dispatch('index', 'timeout');
    },
    doLogout() {
      this.dispatch('index', 'logout');
    },
    doLogin(backUrl = '') {
      if (backUrl != null && !backUrl) {
        backUrl = this.$route.path;
      }
      this.dispatch('index', 'login', {backUrl: backUrl});
    },
    initUI() {
      let pagebody = window.document.getElementsByClassName('jy-pageBody'), pagefooter = window.document.getElementsByClassName('jy-pageFooter'), nav = window.document.getElementById('jy-breadcrumb');
      if (pagebody && pagebody[0]) {
        pagebody = pagebody[0];
        if (pagefooter) {
          pagefooter = pagefooter[0];
        }
        setTimeout(() => {
          if (pagebody.scrollHeight > pagebody.offsetHeight) {
            //nav.style.width = 'calc(100% - 17px)';
            //pagefooter && (pagefooter.style.right = '17px');
          } else {
            //nav.style.width = '100%';
            //pagefooter && (pagefooter.style.right = '0');
          }
        }, 400);
      }
    },
    // 同步编辑器内容
    syncEditor() {
      this.broadcast('JyEditor', 'jy.editor.sync');
    },
    // 验证提交form
    submitform(_form = 'editForm') {
      this.syncEditor();
      let form = this.$refs[_form];
      if (!form) {
        this.$message('提交form的ref不正确！');
        return;
      }
      let callback;
      const promise = new window.Promise((resolve, reject) => {
        callback = function(valid) {
          valid ? resolve(valid) : reject(valid);
        };
      });
      form.validate(valid => {
        callback(valid);
      });
      
      return promise;
    },
    uploadCb(response, options) {
      let json = JSON.parse(response);
      if (json && json[types.KEY_STATUS]) {
        if (json[types.KEY_STATUS] >= 200) {
          if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
            options.okcb && (options.okcb.call(this, json.obj));
            options.cb && (options.cb.call(this, json));
          } else {
            options.cb && (options.cb.call(this, json));
            options.errcb && (options.errcb.call(this, json));
          }
        } else {
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, json));
      }
    },
    httpCb(flag, response, options) {
      if (flag) {
        let json = response.data;

        if (json && json[types.KEY_STATUS]) {
          if (json[types.KEY_STATUS] >= 200) {
            if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
              options.okcb && (options.okcb.call(this, json.obj, json.message));
              options.cb && (options.cb.call(this, json));
            } else {
              options.cb && (options.cb.call(this, json));
              options.errcb && (options.errcb.call(this, response.data));

              this.$message.error
                ? this.$message.error(json.message)
                : this.Notify(json.message);
            }
          } else {
            options.cb && (options.cb.call(this, json));
          }
        } else {
          //options.okcb && (options.okcb.call(this, json));
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, response.data));
        options.errcb && (options.errcb.call(this, response.data));
        response.data && (
          this.$message.error
                ? this.$message.error(json.message)
                : this.Notify(json.message)
        );
      }
    },
    httpCb1(flag, response, options) {
      if (flag) {
        let json = response.body;

        if (json && json[types.KEY_STATUS]) {
          if (json[types.KEY_STATUS] >= 200) {
            if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
              options.okcb && (options.okcb.call(this, json.obj));
              options.cb && (options.cb.call(this, json));
            } else {
              options.cb && (options.cb.call(this, json));
              options.errcb && (options.errcb.call(this, response.body));
              this.$message.error(json.message);
            }
          } else {
            options.cb && (options.cb.call(this, json));
          }
        } else {
          //options.okcb && (options.okcb.call(this, json));
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, response.body));
        options.errcb && (options.errcb.call(this, response.body));
        this.$message.error(response.body);
      }
    },
    doGet(options) {
      let data = options.data || {};
      this.$axios.get(options.url, {headers: this.headers, params: data, withCredentials:true})
        .then((response) => {
          this.httpCb(true, response, options);
        })
        .catch((response) => {
          this.httpCb(false, response, options);
        });
    },
    // doGet1(options) {
    //   let data = options.data || {};
    //   this.$http.get(options.url, {params: data}).then((response) => {
    //     this.httpCb(true, response, options);
    //   }, (response) => {
    //     this.httpCb(false, response, options);
    //   });
    // },
    doPost(options) {
      let data = options.data || {};
      this.$axios.post(options.url, data, {headers: this.headers, withCredentials:true})
        .then((response) => {
          this.httpCb(true, response, options);
        })
        .catch((response) => {
          this.httpCb(false, response, options);
        });
    },
    // doPost1(options) {
    //   let data = options.data || {};
    //   this.$http.post(options.url, data).then((response) => {
    //     this.httpCb(true, response, options);
    //   }, (response) => {
    //     this.httpCb(false, response, options);
    //   });
    // },
    // 性别
    showSex(sex) {
      if (sex === null || sex === undefined) {
        return '';
      }
      if (sex == true) {
        sex = '01';
      } else if (sex == false) {
        sex = '02';
      }
      return this.sexLabel[sex];
    },
    // 格式化日期
    formatDate(date, fmt = 'yyyy-MM-dd') {
      if (!date) {
        return date;
      }
      // console.log(date)
      let _date = date;
      if (!(_date instanceof Date)) {
        if (typeof _date === 'string') {
          _date = _date.toDate();
        } else if (typeof _date === 'number') {
          _date = new Date(_date);
        }
      }
      if (!(_date instanceof Date)) {
        return date;
      }
      return formatDate(_date, fmt);
    },
    // 检查权限
    hasPermiss(permiss) {
      return this.userinfo.permissions.indexOf(permiss) > -1;
    },
    // 判断是否本公司
    isSelfCompany(companyid) {
      return companyid == this.userinfo.companyid;
    },
    // 确认提示
    msgbox(msg, okcb, options) {
      options = options || {};
      this.$confirm(msg, options.title || '提示', {
        confirmButtonText: options.confirmButtonText || '确定',
        cancelButtonText: options.cancelButtonText || '取消',
        type: options.type || 'warning'
      }).then(() => {
        okcb && okcb.apply();
      }).catch(() => {
        options.cancelcb && options.cancelcb.apply();
      });
    },
    // 提示保存
    confirmSave(msg, done, cancel) {
      // 判断是否需要保存
      if (JSON.stringify(this.editData) !== this.originData) {
        this.msgbox(
          msg,
          () => {
            done();
            let obj = JSON.parse(this.originData);
            for (let key of Object.keys(obj)) {
              this.editData[key] = obj[key];
            }
          },
          {
            cancelcb: cancel
          }
        )
      } else {
        done();
      }
    },
    // 保存原始editData
    setOriaData(delay, cb) {
      setTimeout(() => {
        this.originData = JSON.stringify(this.editData);
        if (cb)
          cb();
      }, delay !== undefined ? delay : 500);
    },
    // 清除jy.grid
    clearGridData(data) {
      let delGrid = (_data) => {
        Object.keys(_data).forEach(k => {
          if (k.startsWith('jy.grid')) {
            delete _data[k];
          }
        });
      };
      Array.isArray(data)
        ? data.forEach(_d => { delGrid(_d) })
        : delGrid(data);
    },
    // card模式，hover
    enterCard(ishover, $e) {
      let _class = 'border-danger';
      let target = $e.target;
      if (ishover) {
        addClass(target, _class);
      } else {
        removeClass(target, _class);
      }
    },
    // 滚动到指定ref
    scroll2Ref(ref, scrollContainer) {
      let $ref = this.$refs[ref];
      if ($ref) {
        let offsetTop = getAbsPoint($ref.$el).y;
        scrollContainer.scrollTop = offsetTop;
      }
    },
    // 打开帮助窗口
    doHelp(navname) {
      ///help-view/'+ (navname || '')
      window.open(this.BASEPATH +'/help/#/help-view/'+ navname, '_blank', 'top=100,left=100,width=600,height=400,menubar=no,location=no,scrollbars=yes,toolbar=no,status=no');
      //window.open(this.rootPath + 'sys/help/content/getByNavname', '_blank', 'top=100,left=100,width=500,height=400,menubar=no,scrollbars=no,toolbar=no,status=no');
    },
    triggerActivated() {
      console.log('trigger.......')
      this.$emit('jy.activated');
      this.broadcast('JyPagebody', 'jy.activated', []);
      this.broadcast('JyDialog', 'jy.activated', []);
    }
  },
  activated () {
    this.initUI();
    // console.log('...activated...')
    this.$emit('jy.activated');

    this.broadcast('JyPagebody', 'jy.activated', []);
    //this.broadcast('JyDialog', 'jy.activated', []);
    this.broadcast('JyField', 'jy.field.validate', [true]);
  },
  deactivated () {
    this.broadcast('JyPagebody', 'jy.deactivated', []);
    this.broadcast('JyDialog', 'jy.deactivated', []);
    this.broadcast('JyField', 'jy.field.validate', [false]);
  },
  destroyed () {
    this.broadcast('JyField', 'jy.field.validate', [false]);
  }
}
